import { useQuery } from '@tanstack/react-query';
import { QueryKeys } from 'src/constants';
import ApiService from 'src/modules/api-service';

export const useConditionalFormats = () =>
  useQuery([QueryKeys.conditionalFormats], () =>
    ApiService.config.configControllerGetConditionalFormatting().then((res) => res.data),
  );
